import { Stack, Typography, useTheme } from "@mui/material";
import { CopySupportMail } from "./CopySupportMail";
import { Button, Input, RadioButtonGroup, SelectField } from "components";
import {
  useFetchAllEmailAssignees,
  useGetAllBoards,
  useUpdateEmailAccount,
} from "controller";
import { Height } from "@mui/icons-material";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { ServerTypeCompoenent } from "./ServerTypeComponent";
import { SelectAssignees } from "./mail-server";
import { MailBoxSection } from "./mail-server/MailBoxSection";

export const DefaultMailServer = forwardRef(
  (
    {
      emailConfigData,
    }: {
      emailConfigData?: any;
    },
    ref,
  ) => {
    const [resourceSelectionState, setResourceSelectionState] = useState(false);
    const [selectedResources, setSelectedResources] = useState<Array<string>>(
      [],
    );

    const detailsRef = useRef<any>(null);

    const { data: currentSelectedAssignees } = useFetchAllEmailAssignees(
      emailConfigData?.mapping_id,
    );

    useEffect(() => {
      Array.isArray(currentSelectedAssignees)
        ? setSelectedResources(currentSelectedAssignees)
        : setSelectedResources([]);
    }, [currentSelectedAssignees]);

    const selectAssigneeFuntion = () => {
      setResourceSelectionState(!resourceSelectionState);
    };

    const onRemoveAssignee = (mappingId: any) => {
      setSelectedResources((prev: any) =>
        prev.filter((a: any) => a.mapping_id !== mappingId),
      );
    };

    const submit: any = async () => {
      if (detailsRef.current) {
        const result = await detailsRef.current.submit();
        if (result) {
          return {
            assignees: selectedResources.map(
              (assignee: any) => assignee?.mapping_id,
            ),
            ...result,
            display_from: result?.display_from,
          };
        }
      }
    };

    useImperativeHandle(ref, () => ({
      submit,
    }));

    return (
      <Stack
        direction={"row"}
        sx={{
          height: "100%",
          padding: "8px",
          gap: "8px",
          width: "100%",
        }}
      >
        {/* left block  */}
        <Stack
          p="8px"
          gap="8px"
          sx={{
            flex: 1,
            width: "624px",
            // width: "min( 624px , calc( 50vw - 32px))",
            height: "100%",
            bgcolor: "#F6F6F5",
            borderRadius: "8px",
          }}
        >
          <Stack
            sx={{
              bgcolor: "#FFFF",
              p: "24px",
              gap: "24px",
              borderRadius: "8px",
            }}
          >
            {/* <ServerTypeCompoenent
            serverType={"default"}
            setServerType={onServerTypeChange}
          /> */}
            <Stack gap={"4px"}>
              <Typography variant="caption-3">Support email</Typography>
              {emailConfigData?.support_email && (
                <CopySupportMail email={emailConfigData?.support_email} />
              )}
            </Stack>
          </Stack>
          <MailBoxSection
            ref={detailsRef}
            selectedResources={selectedResources}
            onSelectAssigneeClicked={selectAssigneeFuntion}
            onRemoveAssigneeClicked={onRemoveAssignee}
            board={emailConfigData?.board}
            customDisplayName={emailConfigData?.custom_display_name}
            displayFrom={emailConfigData?.display_from}
          />
        </Stack>
        {/* right block  */}
        {resourceSelectionState && (
          <Stack
            p="8px"
            gap="8px"
            sx={{
              flex: 1,
              maxWidth: "624px",
              // width: "min( 624px , calc(50vw - 32px))",
              height: "100%",
              // height: "400px",
              bgcolor: "#F6F6F5",
              borderRadius: "8px",
              transition: "all 0.3s ease-in-out",
            }}
          >
            <SelectAssignees
              selectedAssignees={selectedResources}
              setSelectedAssignees={(value) => {
                setSelectedResources(value);
              }}
            />
          </Stack>
        )}
      </Stack>
    );
  },
);
